module.exports = __webpack_public_path__ + "static/whatsapp-icon-66dfcc3339a64498814b139d313dd148.png";